import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

const ForgetPassword = ({
  showForgotPassword,
  setShowForgotPassword,
  setResetEmail,
  resetEmail,
  resetLoading,
  handleResetPassword,
}) => {
  return (
    <Dialog open={showForgotPassword} onOpenChange={setShowForgotPassword}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reset Password</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-3 px-6">
          <Label htmlFor="reset-email">Enter your email</Label>
          <Input
            id="reset-email"
            type="email"
            placeholder="m@example.com"
            value={resetEmail}
            onChange={(e) => setResetEmail(e.target.value)}
            disabled={resetLoading}
            pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            title="Enter a valid email address (e.g., name@example.com)"
          />
        </div>
        <DialogFooter>
          <Button
            onClick={handleResetPassword}
            disabled={resetLoading || !resetEmail.trim()}
            variant="outline"
          >
            {resetLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ForgetPassword;
